<template>
  <gkModal v-model="visible" class="modal-receive-success" title="领取成功">
    <div class="content">
      <template v-if="!isMobile">
        <p class="text">下载「极客时间」App 或访问 <a target="_black" href="//time.geekbang.org" rel="noopener nofollow">极客时间官网</a></p>
        <p class="text">即可开始学习，此课程限时免费学习 7 天</p>
      </template>
      <template v-else>
        <p class="text">下载「极客时间」App 或</p>
        <p class="text">访问 <a target="_black" href="//time.geekbang.org" rel="noopener nofollow">极客时间官网</a> 即可开始学习</p>
        <p class="text">此课程限时免费学习 7 天</p>
      </template>
      <div class="qrcode">
        <img src="./image/app-qrcode.png" />
      </div>
      <p class="tip">扫码下载「极客时间」App</p>
    </div>
    <div class="footer" slot="footer"></div>
  </gkModal>
</template>

<script>
import gkModal from 'gkuiV2/modal'

export default {
  name: 'modal-receive-success',
  components: {
    gkModal
  },
  props: {
  },
  data () {
    return {
      visible: false
    }
  },
  computed: {
    isMobile () {
      const ua = navigator.userAgent.toLowerCase()
      return /iphone|android|ucweb|ucbrowser|nokia|sony|ericsson|mot|samsung|sgh|lg|philips|panasonic|alcatel|lenovo|cldc|midp|wap|mobile/i.test(ua) && !/ipad/i.test(ua) || document.body.clientWidth <= 768
    }
  },
  methods: {
    show () {
      this.visible = true
    },
    hide () {
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/_common';

.modal-receive-success {
  & ::v-deep {
    & [gk-modal-main] {
      box-sizing: border-box;
      width: 424px;

      @include mobile () {
        top: 0;
        width: 310px; min-height: auto;
        padding: 34px 24px 23px;
      }
    }
    & [gk-modal-title] {
      text-align: center;
    }
  }
}

.content {
  margin-top: 23px;
}

.text {
  text-align: center;
  line-height: 24px;
  @include font(16, 400);
  color: $lightBlack;

  @include mobile () {
    font-size: 14px;
  }
}

.qrcode {
  width: 132px; height: 132px;
  margin: 21px auto 22px;

  & img {
    width: 100%; height: 100%;
  }
}

.tip {
  text-align: center;
  @include lineFont(14, 400);
  color: $gray;
}
</style>
